import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SalesOrders_ds_sales_order_multi_shipments_load_shipmentsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get($inParams: { order_id: number, full_text_search?: string }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, ExpectedDate?: string, LookupCode?: string, StatusId?: number, ShipmentLines?: { Id?: number, ExpectedPackagedAmount?: number }[], Tasks?: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, OperationCodeId?: number, StatusId?: number }[], DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number, ShipmentId?: number, DockAppointment?: { Id?: number, AssignedlLocationContainerId?: number, ScheduledLocationContainerId?: number, ScheduledLocation?: { Id?: number, Name?: string, ChildLocationContainers?: { Id?: number, IsLoose?: boolean, Name?: string }[] } } }[] } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getList($inParams: { order_id: number, full_text_search?: string, $top?: number, $skip?: number }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, ExpectedDate?: string, LookupCode?: string, StatusId?: number, ShipmentLines?: { Id?: number, ExpectedPackagedAmount?: number }[], Tasks?: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, OperationCodeId?: number, StatusId?: number }[], DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number, ShipmentId?: number, DockAppointment?: { Id?: number, AssignedlLocationContainerId?: number, ScheduledLocationContainerId?: number, ScheduledLocation?: { Id?: number, Name?: string, ChildLocationContainers?: { Id?: number, IsLoose?: boolean, Name?: string }[] } } }[] } }[], totalCount: number }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }
  public async getByKeys($inParams: { order_id: number, full_text_search?: string, $keys: { OrderId?: number, ShipmentId?: number }[] }): 
  Promise<{ result: { OrderId?: number, ShipmentId?: number, Shipment?: { Id?: number, ExpectedDate?: string, LookupCode?: string, StatusId?: number, ShipmentLines?: { Id?: number, ExpectedPackagedAmount?: number }[], Tasks?: { Id?: number, ActualPackagedAmount?: number, ActualTargetLicensePlateId?: number, OperationCodeId?: number, StatusId?: number }[], DockAppointmentsShipmentsLookup?: { DockAppointmentId?: number, ShipmentId?: number, DockAppointment?: { Id?: number, AssignedlLocationContainerId?: number, ScheduledLocationContainerId?: number, ScheduledLocation?: { Id?: number, Name?: string, ChildLocationContainers?: { Id?: number, IsLoose?: boolean, Name?: string }[] } } }[] } }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.order_id)) {
      $missingRequiredInParams.push('\'order_id\'');
    }
    if (isNil($inParams.$keys)) {
      $missingRequiredInParams.push('\'$keys\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }


    
    hasMissingRequiredInParams($inParams: { 
      order_id: number, full_text_search?: string    }) {
        if(isNil($inParams.order_id)) {
          return true; 
        }
      return false;
    }
}
